module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_7005.3f1aca68.png";